import androidx.compose.runtime.*
import kotlinx.browser.window
import kotlinx.coroutines.CancellationException
import org.jetbrains.compose.web.dom.*
import org.jetbrains.compose.web.attributes.*

/** Public summary is available even while registrations are still closed. */
@Composable
fun TourPublicTournament(slug: String) {
    TourSeasonScope(null, showSeason = false, includeFinished = true) { _, tournaments ->
        val t = tournaments.firstOrNull { it.slug == slug }
        LaunchedEffect(t?.status, slug) {
            if (t?.status == "finished") window.location.replace(tourBase() + "/vysledky/" + slug)
        }
        if (t?.status == "finished") return@TourSeasonScope
        var slots by remember(slug) { mutableStateOf<List<TourSlotDto>>(emptyList()) }
        var error by remember(slug) { mutableStateOf<String?>(null) }
        var retry by remember(slug) { mutableStateOf(0) }
        LaunchedEffect(t?.id, retry) {
            slots = emptyList(); error = null
            if (t != null && t.status in listOf("published", "open")) try {
                slots = TourApi.rows("tour_slot", null, "round_no", mapOf("tournament_id" to "eq.${t.id}"))
            } catch (e: Throwable) { if (e is CancellationException) throw e; error = e.apiMessage() }
        }
        Div(attrs = { classes("card") }) {
            A(href = tourBase() + "/") { Text("← Aktuálně") }
            H2 { Text(t?.title ?: "Turnaj nebyl nalezen") }
            t?.let {
                P { Text("${it.startsOn?.let(::formatDate) ?: "Termín bude upřesněn"} · ${tourLabel(it.discipline, TOUR_DISCIPLINES)}") }
                P { Text(tourLabel(it.status, TOUR_TOURNAMENT_STATES)) }
                if (it.description.isNotBlank()) P { Text(it.description) }
                if (it.status == "published") P { Text("Přihlášky zatím nejsou otevřené. Jejich otevření oznámí pořadatel.") }
                slots.forEach { slot -> P { Text("${slot.roundNo}. runda · ${slot.startsAt.take(5)} · kapacita ${slot.capacity} hráčů") } }
                TourError(error)
                if (error != null) Button(attrs = { onClick { retry++ } }) { Text("Načíst rundy znovu") }
                Div(attrs = { classes("tour-detail-links") }) {
                    if (it.status == "open") A(href = tourBase() + "/obsazovacka/" + it.slug) { Text("Obsazovačka a rozlosování →") }
                    if (it.status in listOf("running", "finished")) A(href = tourBase() + "/vysledky/" + it.slug) { Text("Výsledky a náhozy →") }
                }
            }
        }
    }
}
